import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import CategoryTitle from "../../category/core/CategoryTitle.tsx";

const ItemCategory = ({ id }: { id: string }) => {
  const { item, isLoading, isError } = useItem(id, EMPTY_ITEM);
  if (isLoading) return "Titel...";
  if (isError) return isError;
  return <CategoryTitle slug={item.category} />;
};
export default ItemCategory;
